/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  PDF_SECTION_TITLE_RENDERED: null,
  PDF_HEADING_RENDERED: null,
  PDF_DESCRIPTION_RENDERED: null,
  PDF_DOWNLOAD_LINK_RENDERED: null,
  PDF_PREVIEW_RENDERED: null,
  PDF_PREV_BTN_RENDERED: null,
  PDF_NEXT_BTN_RENDERED: null,
  PDF_PAGE_NOTATION_RENDERED: null,
  PDF_NONDISPLAY_PLACEHOLDER_RENDERED: null,
  PDF_DISPLAY_PLACEHOLDER_RENDERED: null,
  PDF_LINK_OVERLAY: null,
  PDF_LOADING_ANIMATION: null,
  PDF_INT_OBS: null
});
